module.exports = "<app-category-list></app-category-list>\n"